export const SAMPLE = {
  "values": {
  "production": {
    "label": "production",
    "deviceTimeValues": {
      "0518d382-c229-4b95-a6b6-34390d8f2767": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0.0059126666666666665
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0.007513333333333333
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0.009767333333333335
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0.014863333333333332
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0.022376666666666665
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0.027897333333333325
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0.03407133333333333
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0.03808933333333333
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0.03897133333333332
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0.04122533333333333
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0.05732999999999998
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0.10979266666666666
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0.141022
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0.2115493333333333
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0.25689066666666673
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0.3141553333333334
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0.40601399999999995
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0.6611080000000001
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 1.0502986666666668
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 1.3380919999999996
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 1.6145499999999997
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 1.8929353333333338
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 2.1847140000000004
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 2.4453613333333333
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 2.735212666666667
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 3.024606666666667
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 3.278818666666667
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 3.53339
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 3.7323953333333343
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 3.984059333333333
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 4.220076
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 4.492091333333333
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 4.684726666666668
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 4.909506
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 5.095444666666665
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 5.278214666666667
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 5.4684980000000005
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 5.618405333333333
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 5.793760000000001
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 5.962091333333332
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": 6.1199693333333325
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 6.293625333333333
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 6.3015960000000005
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 6.625486
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 6.788263999999998
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 6.939184
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 7.058515333333333
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 6.969988666666667
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 6.491683333333334
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 6.819539999999998
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 6.826614666666665
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 7.0921946666666645
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 7.180133333333332
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 7.631227333333334
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 7.819812000000002
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 7.8554186666666665
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 7.9268933333333325
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 7.938620666666667
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 7.968804666666669
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 8.011140666666665
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 8.059781333333334
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 8.1150206666666645
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 8.151247999999999
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 8.195348
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 8.226185333333333
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 8.295275333333333
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 8.271983999999999
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 8.401458333333334
        }
      ],
      "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0.0024173333333333336
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0.0070233333333333325
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0.0067620000000000005
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0.00966933333333333
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0.01225
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0.019698
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0.02113533333333333
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0.026819333333333336
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0.031523333333333333
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0.03560666666666667
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0.037436
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0.04442666666666667
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0.06686866666666666
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0.09522333333333334
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0.12341466666666669
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0.10884533333333333
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0.153272
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 0.184926
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 0.20932799999999997
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 0.22392999999999998
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0.251174
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0.26522066666666666
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0.28063933333333335
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 0.3084386666666667
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 0.3372833333333332
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 0.35652400000000006
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 0.36710799999999995
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 0.3839313333333333
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 0.4107833333333334
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 0.4318860000000002
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 0.4524660000000001
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 0.46158
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 0.4731766666666666
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 0.4882686666666667
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 0.50136800000000005
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 0.5164926666666667
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 0.5381506666666667
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 0.5658520000000001
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 0.5795066666666667
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": 0.5867260000000001
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 0.5996946666666668
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 0.6149500000000002
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 0.6346479999999998
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 0.6550973333333334
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 0.6648319999999999
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 0.6686213333333332
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 0.6710386666666668
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 0.6526800000000001
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 0.6717550000000001
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 0.6838113333333333
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 0.6960286666666666
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 0.6974660000000001
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 0.7169680000000001
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 0.7266373333333333
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 0.7458453333333332
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 0.7817786666666666
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 0.8214033333333333
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 0.8737353333333334
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 0.9391013333333334
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 1.01675
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 1.1417
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 1.2552166666666667
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 1.4045686666666663
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 1.5583960000000002
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 1.7460006666666663
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 1.7866706666666666
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 1.8658383333333334
        }
      ]
    },
    "deviceNames": {
      "0518d382-c229-4b95-a6b6-34390d8f2767": "Solar-Ost",
      "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac": "Solar-West"
    },
    "timeBucket": "5 minutes"
  },
  "consumption": {
    "label": "consumption",
    "deviceTimeValues": {
      "4581f36f-9661-470f-b1ba-c358992a4712": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": -0.9902333333333333
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": -1.0032666666666667
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": -0.9887333333333333
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": -0.8611033333333332
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": -0.9712333333333333
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": -0.888908
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": -1.1229666666666667
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": -1.0068
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": -0.9996666666666666
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": -1.0011
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": -0.995
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": -0.995
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": -0.9883666666666667
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": -0.9998
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": -1.0126333333333333
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": -0.9954666666666667
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": -0.9159913333333334
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": -0.9647333333333333
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": -0.9349333333333333
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": -1.0224666666666667
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": -1.0187333333333333
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": -0.9830666666666667
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": -1.0375333333333335
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": -1.060968
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": -1.0383393333333333
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": -1.0404913333333332
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": -1.0496413333333335
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": -1.0115
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": -1.0352513333333334
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": -1.0125333333333333
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": -1.0332586666666668
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": -2.2526646666666666
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": -0.9557333333333333
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": -0.9655666666666667
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": -1.0181666666666666
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": -1.0018333333333334
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": -1.0015666666666667
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": -0.9087
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": -1.0040333333333333
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": -1.0046
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": -0.9958666666666667
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": -1.0071
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": -0.9954
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": -0.9925
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": -0.884832
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": -0.9680333333333333
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": -0.9531333333333333
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": -0.9610666666666667
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": -0.9522666666666667
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": -1.0227333333333333
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": -0.9969466666666672
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": -0.9748333333333335
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": -0.9882913333333335
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": -0.9701939999999997
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": -0.9624459999999997
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": -0.9537993333333332
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": -0.9406753333333334
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": -0.9357186666666665
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": -0.8157653333333334
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": -0.8907599999999999
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": -1.6978146666666662
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": -1.8365593333333334
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": -1.7747920000000001
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": -1.7029279999999999
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": -1.610396
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": -1.4161613333333335
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": -1.522080666666667
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": -1.178040666666667
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": -0.7642606666666669
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": -0.43785733333333343
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": -0.15694333333333336
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0.14752866666666665
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0.4432820000000001
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0.7233493333333334
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 1.054437333333333
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 1.3691153333333334
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 1.6305553333333332
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 1.8921886666666674
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 2.1386946666666668
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 2.3879353333333333
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 2.6692673333333337
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 3.067366666666667
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 3.1753393333333324
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 3.404840666666668
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 3.593618
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 3.8255520000000006
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 4.038890666666666
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 4.083258
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 4.349240666666667
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 4.493878
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": 4.627195333333333
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 4.899276000000001
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 4.9108
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 5.291064666666668
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 5.453396666666667
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 5.615859333333332
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 5.796409333333334
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 5.637775333333334
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 5.166682666666665
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 5.473675000000001
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 5.5423866666666645
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 5.808007333333332
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 5.773414666666667
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 6.3342413333333325
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 6.538177999999999
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 6.599629333333333
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 6.730618666666666
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 6.795461333333335
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 6.840656666666668
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 7.055134666666667
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 7.094610000000001
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 7.261604
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 7.415840666666666
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 7.598656
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 7.793061333333333
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 8.010775333333333
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 8.141967333333334
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 8.228758333333333
        }
      ]
    },
    "deviceNames": {
      "4581f36f-9661-470f-b1ba-c358992a4712": "Allgemein"
    },
    "timeBucket": "5 minutes"
  },
  "batteryCharge": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0.09993333333333334
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0.0999
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": 0.09996666666666667
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": 0.09956666666666666
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 0.1
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "5 minutes"
  },
  "batteryPower": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": -0.03893866666666667
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": -0.016072
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": -0.06628066666666668
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0.025349333333333334
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0.021984666666666666
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0.07823666666666666
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 0.050372
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0.0012413333333333334
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": 0.015712666666666667
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": 1.4075086666666668
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": -0.002156
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": -0.029922666666666665
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": -0.005586
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": -0.002972666666666667
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 0.0
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 0.0
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "5 minutes"
  },
  "batteryPowerPositive": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0.38024
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0.65954
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0.782366666666667
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 1.51116
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0.03724
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": 0.5341
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": 3.57169166666667
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T22:00:00.000Z",
          "value": 0
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "5 minutes"
  },
  "batteryPowerNegative": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": -1.16816
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": -0.48216
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": -1.98842
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": -0.06272
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": -0.63504
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": -0.06468
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": -0.89768
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": -0.16758
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": -0.08918
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T22:00:00.000Z",
          "value": 0
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "5 minutes"
  },
  "grid": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": -0.9902333333333333
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": -1.0032666666666667
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": -0.9887333333333333
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": -0.9233333333333334
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": -0.9712333333333333
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": -0.9709666666666667
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": -1.1229666666666667
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": -1.0068
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": -0.9996666666666666
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": -1.0011
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": -0.995
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": -0.995
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": -0.9883666666666667
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": -0.9998
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": -1.0126333333333333
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": -0.9954666666666667
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": -0.9400666666666667
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": -0.9647333333333333
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": -0.9349333333333333
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": -1.0224666666666667
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": -1.0187333333333333
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": -0.9830666666666667
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": -1.0032333333333333
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": -1.0169333333333333
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": -0.9896333333333333
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": -0.9943333333333334
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": -1.0500333333333333
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": -1.0115
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": -0.9822333333333333
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": -1.0125333333333333
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": -1.0328666666666666
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": -0.8724
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": -0.9557333333333333
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": -0.9655666666666667
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": -1.0181666666666666
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": -1.0018333333333334
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": -1.0015666666666667
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": -0.9087
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": -1.0040333333333333
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": -1.0046
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": -0.9958666666666667
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": -1.0071
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": -0.9954
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": -0.9925
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": -0.8913
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": -0.9680333333333333
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": -0.9531333333333333
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": -0.9610666666666667
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": -0.9522666666666667
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": -1.0227333333333333
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": -1.0025
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": -0.9846333333333333
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": -1.0025666666666667
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": -0.9895
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": -0.9892
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": -0.9913333333333334
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": -0.9901
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": -0.9954333333333333
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": -1.0149666666666667
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": -0.9639333333333333
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": -1.7916333333333334
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": -1.9783
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": -1.9622333333333333
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": -1.9787
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": -1.9613666666666666
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": -1.8569
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": -2.0356333333333334
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": -1.9852666666666667
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": -1.9938666666666666
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": -1.9841666666666667
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": -1.9998333333333333
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": -2.0038
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": -2.0027
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": -2.0035333333333333
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": -1.9915333333333333
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": -1.9882666666666667
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": -2.0090666666666666
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": -2.0038666666666666
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": -1.9824666666666667
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": -2.0056333333333334
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": -1.9824333333333334
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": -1.8751
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": -1.9726333333333334
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": -1.9799
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": -1.9800666666666666
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": -1.9555333333333333
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": -1.951
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": -2.083
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": -2.0040666666666666
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": -2.0454333333333334
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": -2.0925666666666666
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": -1.9945666666666666
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": -2.008
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": -1.9773666666666666
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": -1.9849666666666667
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": -1.9876666666666667
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": -1.9271666666666667
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": -2.0025333333333333
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": -1.9865333333333333
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": -2.0235
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": -1.9716
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": -1.9761
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": -2.1001666666666665
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": -2.0084333333333334
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": -2.0134
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": -1.9951666666666667
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": -1.9774
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": -1.9611
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": -1.9945333333333333
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": -1.8971
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": -1.9797
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": -1.9926666666666667
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": -1.9852666666666667
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": -1.9944333333333334
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": -1.9941333333333334
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": -2.0272666666666667
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": -1.9291333333333334
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": -2.0240833333333333
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "5 minutes"
  },
  "gridPositive": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": 0.018
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": 0.206
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": 0.599
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": 0.985
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": 0.977
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": 1.467
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": 0.345
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": 0.233
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T22:00:00.000Z",
          "value": 0
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "5 minutes"
  },
  "gridNegative": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": -0.990233333333333
        },
        {
          "read": "2025-06-25T22:05:00.000Z",
          "value": -1.00326666666667
        },
        {
          "read": "2025-06-25T22:10:00.000Z",
          "value": -0.988733333333333
        },
        {
          "read": "2025-06-25T22:15:00.000Z",
          "value": -0.923333333333333
        },
        {
          "read": "2025-06-25T22:20:00.000Z",
          "value": -0.971233333333333
        },
        {
          "read": "2025-06-25T22:25:00.000Z",
          "value": -0.970966666666667
        },
        {
          "read": "2025-06-25T22:30:00.000Z",
          "value": -1.12296666666667
        },
        {
          "read": "2025-06-25T22:35:00.000Z",
          "value": -1.0068
        },
        {
          "read": "2025-06-25T22:40:00.000Z",
          "value": -0.999666666666667
        },
        {
          "read": "2025-06-25T22:45:00.000Z",
          "value": -1.0011
        },
        {
          "read": "2025-06-25T22:50:00.000Z",
          "value": -0.995
        },
        {
          "read": "2025-06-25T22:55:00.000Z",
          "value": -0.995
        },
        {
          "read": "2025-06-25T23:00:00.000Z",
          "value": -0.988366666666667
        },
        {
          "read": "2025-06-25T23:05:00.000Z",
          "value": -0.9998
        },
        {
          "read": "2025-06-25T23:10:00.000Z",
          "value": -1.01263333333333
        },
        {
          "read": "2025-06-25T23:15:00.000Z",
          "value": -0.995466666666667
        },
        {
          "read": "2025-06-25T23:20:00.000Z",
          "value": -0.940066666666667
        },
        {
          "read": "2025-06-25T23:25:00.000Z",
          "value": -0.964733333333333
        },
        {
          "read": "2025-06-25T23:30:00.000Z",
          "value": -0.934933333333333
        },
        {
          "read": "2025-06-25T23:35:00.000Z",
          "value": -1.02246666666667
        },
        {
          "read": "2025-06-25T23:40:00.000Z",
          "value": -1.01873333333333
        },
        {
          "read": "2025-06-25T23:45:00.000Z",
          "value": -0.983066666666667
        },
        {
          "read": "2025-06-25T23:50:00.000Z",
          "value": -1.03844827586207
        },
        {
          "read": "2025-06-25T23:55:00.000Z",
          "value": -1.01693333333333
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": -0.989633333333333
        },
        {
          "read": "2025-06-26T00:05:00.000Z",
          "value": -1.03572413793103
        },
        {
          "read": "2025-06-26T00:10:00.000Z",
          "value": -1.05003333333333
        },
        {
          "read": "2025-06-26T00:15:00.000Z",
          "value": -1.0115
        },
        {
          "read": "2025-06-26T00:20:00.000Z",
          "value": -1.03675862068966
        },
        {
          "read": "2025-06-26T00:25:00.000Z",
          "value": -1.01253333333333
        },
        {
          "read": "2025-06-26T00:30:00.000Z",
          "value": -1.03286666666667
        },
        {
          "read": "2025-06-26T00:35:00.000Z",
          "value": -0.936448275862069
        },
        {
          "read": "2025-06-26T00:40:00.000Z",
          "value": -0.955733333333333
        },
        {
          "read": "2025-06-26T00:45:00.000Z",
          "value": -0.965566666666667
        },
        {
          "read": "2025-06-26T00:50:00.000Z",
          "value": -1.01816666666667
        },
        {
          "read": "2025-06-26T00:55:00.000Z",
          "value": -1.00183333333333
        },
        {
          "read": "2025-06-26T01:00:00.000Z",
          "value": -1.00156666666667
        },
        {
          "read": "2025-06-26T01:05:00.000Z",
          "value": -0.973724137931035
        },
        {
          "read": "2025-06-26T01:10:00.000Z",
          "value": -1.00403333333333
        },
        {
          "read": "2025-06-26T01:15:00.000Z",
          "value": -1.0046
        },
        {
          "read": "2025-06-26T01:20:00.000Z",
          "value": -0.995866666666667
        },
        {
          "read": "2025-06-26T01:25:00.000Z",
          "value": -1.0071
        },
        {
          "read": "2025-06-26T01:30:00.000Z",
          "value": -0.9954
        },
        {
          "read": "2025-06-26T01:35:00.000Z",
          "value": -0.9925
        },
        {
          "read": "2025-06-26T01:40:00.000Z",
          "value": -0.972620689655172
        },
        {
          "read": "2025-06-26T01:45:00.000Z",
          "value": -0.968033333333333
        },
        {
          "read": "2025-06-26T01:50:00.000Z",
          "value": -0.953133333333333
        },
        {
          "read": "2025-06-26T01:55:00.000Z",
          "value": -0.961066666666667
        },
        {
          "read": "2025-06-26T02:00:00.000Z",
          "value": -0.997
        },
        {
          "read": "2025-06-26T02:05:00.000Z",
          "value": -1.02273333333333
        },
        {
          "read": "2025-06-26T02:10:00.000Z",
          "value": -1.0025
        },
        {
          "read": "2025-06-26T02:15:00.000Z",
          "value": -0.984633333333333
        },
        {
          "read": "2025-06-26T02:20:00.000Z",
          "value": -1.00256666666667
        },
        {
          "read": "2025-06-26T02:25:00.000Z",
          "value": -0.9895
        },
        {
          "read": "2025-06-26T02:30:00.000Z",
          "value": -0.9892
        },
        {
          "read": "2025-06-26T02:35:00.000Z",
          "value": -0.991333333333333
        },
        {
          "read": "2025-06-26T02:40:00.000Z",
          "value": -0.9901
        },
        {
          "read": "2025-06-26T02:45:00.000Z",
          "value": -0.995433333333333
        },
        {
          "read": "2025-06-26T02:50:00.000Z",
          "value": -1.01496666666667
        },
        {
          "read": "2025-06-26T02:55:00.000Z",
          "value": -0.963933333333333
        },
        {
          "read": "2025-06-26T03:00:00.000Z",
          "value": -1.79163333333333
        },
        {
          "read": "2025-06-26T03:05:00.000Z",
          "value": -1.9783
        },
        {
          "read": "2025-06-26T03:10:00.000Z",
          "value": -1.96223333333333
        },
        {
          "read": "2025-06-26T03:15:00.000Z",
          "value": -1.9787
        },
        {
          "read": "2025-06-26T03:20:00.000Z",
          "value": -1.96136666666667
        },
        {
          "read": "2025-06-26T03:25:00.000Z",
          "value": -1.92896551724138
        },
        {
          "read": "2025-06-26T03:30:00.000Z",
          "value": -2.03563333333333
        },
        {
          "read": "2025-06-26T03:35:00.000Z",
          "value": -1.98526666666667
        },
        {
          "read": "2025-06-26T03:40:00.000Z",
          "value": -1.99386666666667
        },
        {
          "read": "2025-06-26T03:45:00.000Z",
          "value": -1.98416666666667
        },
        {
          "read": "2025-06-26T03:50:00.000Z",
          "value": -1.99983333333333
        },
        {
          "read": "2025-06-26T03:55:00.000Z",
          "value": -2.0038
        },
        {
          "read": "2025-06-26T04:00:00.000Z",
          "value": -2.0027
        },
        {
          "read": "2025-06-26T04:05:00.000Z",
          "value": -2.00353333333333
        },
        {
          "read": "2025-06-26T04:10:00.000Z",
          "value": -1.99153333333333
        },
        {
          "read": "2025-06-26T04:15:00.000Z",
          "value": -1.98826666666667
        },
        {
          "read": "2025-06-26T04:20:00.000Z",
          "value": -2.00906666666667
        },
        {
          "read": "2025-06-26T04:25:00.000Z",
          "value": -2.00386666666667
        },
        {
          "read": "2025-06-26T04:30:00.000Z",
          "value": -1.98246666666667
        },
        {
          "read": "2025-06-26T04:35:00.000Z",
          "value": -2.00563333333333
        },
        {
          "read": "2025-06-26T04:40:00.000Z",
          "value": -1.98243333333333
        },
        {
          "read": "2025-06-26T04:45:00.000Z",
          "value": -1.8751
        },
        {
          "read": "2025-06-26T04:50:00.000Z",
          "value": -1.97263333333333
        },
        {
          "read": "2025-06-26T04:55:00.000Z",
          "value": -1.9799
        },
        {
          "read": "2025-06-26T05:00:00.000Z",
          "value": -1.98006666666667
        },
        {
          "read": "2025-06-26T05:05:00.000Z",
          "value": -1.95553333333333
        },
        {
          "read": "2025-06-26T05:10:00.000Z",
          "value": -1.951
        },
        {
          "read": "2025-06-26T05:15:00.000Z",
          "value": -2.083
        },
        {
          "read": "2025-06-26T05:20:00.000Z",
          "value": -2.00406666666667
        },
        {
          "read": "2025-06-26T05:25:00.000Z",
          "value": -2.04543333333333
        },
        {
          "read": "2025-06-26T05:30:00.000Z",
          "value": -2.09256666666667
        },
        {
          "read": "2025-06-26T05:35:00.000Z",
          "value": -1.99456666666667
        },
        {
          "read": "2025-06-26T05:40:00.000Z",
          "value": -2.008
        },
        {
          "read": "2025-06-26T05:45:00.000Z",
          "value": -1.97736666666667
        },
        {
          "read": "2025-06-26T05:50:00.000Z",
          "value": -1.98496666666667
        },
        {
          "read": "2025-06-26T05:55:00.000Z",
          "value": -1.98766666666667
        },
        {
          "read": "2025-06-26T06:00:00.000Z",
          "value": -1.92716666666667
        },
        {
          "read": "2025-06-26T06:05:00.000Z",
          "value": -2.00253333333333
        },
        {
          "read": "2025-06-26T06:10:00.000Z",
          "value": -1.98653333333333
        },
        {
          "read": "2025-06-26T06:15:00.000Z",
          "value": -2.0235
        },
        {
          "read": "2025-06-26T06:20:00.000Z",
          "value": -1.9716
        },
        {
          "read": "2025-06-26T06:25:00.000Z",
          "value": -1.9761
        },
        {
          "read": "2025-06-26T06:30:00.000Z",
          "value": -2.10016666666667
        },
        {
          "read": "2025-06-26T06:35:00.000Z",
          "value": -2.00843333333333
        },
        {
          "read": "2025-06-26T06:40:00.000Z",
          "value": -2.0134
        },
        {
          "read": "2025-06-26T06:45:00.000Z",
          "value": -1.99516666666667
        },
        {
          "read": "2025-06-26T06:50:00.000Z",
          "value": -1.9774
        },
        {
          "read": "2025-06-26T06:55:00.000Z",
          "value": -1.9611
        },
        {
          "read": "2025-06-26T07:00:00.000Z",
          "value": -1.99453333333333
        },
        {
          "read": "2025-06-26T07:05:00.000Z",
          "value": -1.8971
        },
        {
          "read": "2025-06-26T07:10:00.000Z",
          "value": -1.9797
        },
        {
          "read": "2025-06-26T07:15:00.000Z",
          "value": -1.99266666666667
        },
        {
          "read": "2025-06-26T07:20:00.000Z",
          "value": -1.98526666666667
        },
        {
          "read": "2025-06-26T07:25:00.000Z",
          "value": -1.99443333333333
        },
        {
          "read": "2025-06-26T07:30:00.000Z",
          "value": -1.99413333333333
        },
        {
          "read": "2025-06-26T07:35:00.000Z",
          "value": -2.02726666666667
        },
        {
          "read": "2025-06-26T07:40:00.000Z",
          "value": -1.92913333333333
        },
        {
          "read": "2025-06-26T07:45:00.000Z",
          "value": -2.02408333333333
        },
        {
          "read": "2025-06-26T07:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T07:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T08:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T09:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T10:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T11:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T12:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T13:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T14:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T15:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T16:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T17:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T18:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T19:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T20:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:00:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:05:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:10:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:15:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:20:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:25:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:30:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:35:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:40:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:45:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:50:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T21:55:00.000Z",
          "value": 0
        },
        {
          "read": "2025-06-26T22:00:00.000Z",
          "value": 0
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "5 minutes"
  }
  }
}
